import { render, staticRenderFns } from "./Service_Dialog.vue?vue&type=template&id=6f705637&scoped=true"
import script from "./Service_Dialog.vue?vue&type=script&lang=js"
export * from "./Service_Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f705637",
  null
  
)

export default component.exports